import { useRecoilValue } from 'recoil';
import { useTranslation } from '../../../contexts/TranslationContext';
import { DeviceInfoSection } from './DeviceInfoSection';
import { selectedDeviceStateAtom } from '../../../models/atoms/device_atoms';
import { unix_timestamp_to_date_time } from '../../../utils/helper_functions';
import { MHMTextField } from '../MHM/MHMTextField';
import { DeviceImages } from './DeviceImages';

export function DeviceInstallationInfo({
  canEditSession,
}: {
  canEditSession: boolean;
}) {
  const { t, language } = useTranslation();
  const selectedDevice = useRecoilValue(selectedDeviceStateAtom);

  if (!selectedDevice) {
    return null;
  }

  const installationDate = unix_timestamp_to_date_time(
    selectedDevice.creation_date,
    true,
    true,
    false,
    language,
  );

  // hack to convert seconds to hh:mm:ss format
  const setupTime = new Date(selectedDevice.setup_time_s * 1000)
    .toISOString()
    .slice(11, 19);

  return (
    <DeviceInfoSection>
      <DeviceInfoSection.Heading>
        {t('Installation Info')}
      </DeviceInfoSection.Heading>

      <DeviceInfoSection.TextEntry
        label={t('Installation Date:')}
        text={installationDate}
      />
      <DeviceInfoSection.TextEntry
        label={t('Setup Time (hh:mm:ss):')}
        text={setupTime}
      />
      <DeviceInfoSection.TextEntry
        label={t('Installer:')}
        text={
          selectedDevice.installer_name && selectedDevice.installer_email
            ? `${selectedDevice.installer_name} (${selectedDevice.installer_email})`
            : t('Not available')
        }
      />

      <DeviceInfoSection.Entry label={t('Installation Notes:')}>
        <MHMTextField
          multiline
          fullWidth
          minRows={3}
          disabled
          value={selectedDevice.installation_comment}
          aria-readonly
        />
      </DeviceInfoSection.Entry>

      <DeviceImages canEdit={canEditSession} />
    </DeviceInfoSection>
  );
}
